import React from "react";
import { styled } from "@mui/material";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import img from "../Images/Rectangle.png";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/Add";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../style.css";

var settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 2,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const H2 = styled(Typography)((theme) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "40px",
  lineHeight: "125%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

const P = styled(Typography)(({ theme }) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "150%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

const faQs = [
  {
    title:
      "What does delivering using EatCoast offer that traditional delivery driver jobs don’t ?",
    desc: "Different delivery driver jobs offer different opportunities.    Not all food delivery drivers are able to work flexible hours  whenever they choose. You can decide whether you want a traditional full-time orpart-time delivery driver or courer job, or whether you want to be an independent contractor doing    app-based delivery shenever and whenever you want-or even do both.",
  },
  {
    title:
      "Can i deliver using the EatCoast app and also be a food delivery driver for a restaurant or another delivery app",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.",
  },
  {
    title: "Is the EatCoast platform safe ?",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.",
  },
  {
    title: "What are the requirements to be a delivery driver with EatCoast ?",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.",
  },
];
function Eaist_Way() {
  return (
    <Box sx={{ backgroundColor: "#ffff", margin: 10 }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { lg: "row", md: "row", sm: "column", xs: "column" },
          justifyContent: {
            xl: "space-evenly",
            lg: "space-between",
            md: "space-between",
          },
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: { xl: "47%", lg: "47%", md: "59%", sm: "98%", xs: "98%" },
          }}
        >
          <Slider {...settings}>
            <Box sx={{}}>
              <H2
                sx={{
                  fontSize: {
                    lg: "40px",
                    md: "30px",
                    sm: "20px",
                    xs: "20px",
                  },
                }}
              >
                “EatCoast brings in a lot of business for us. they are the
                easist to work with”
              </H2>
              <P
                sx={{
                  fontSize: {
                    lg: "20px",
                    md: "20px",
                    sm: "16px",
                    xs: "16px",
                  },
                }}
              >
                Alex Prindle, Owner Chef Juna Catering
              </P>
            </Box>
            <Box sx={{}}>
              <H2
                sx={{
                  fontSize: {
                    lg: "40px",
                    md: "30px",
                    sm: "20px",
                    xs: "20px",
                  },
                }}
              >
                “EatCoast brings in a lot of business for us. they are the
                easist to work with”
              </H2>
              <P
                sx={{
                  fontSize: {
                    lg: "20px",
                    md: "20px",
                    sm: "16px",
                    xs: "16px",
                  },
                }}
              >
                Alex Prindle, Owner Chef Juna Catering
              </P>
            </Box>
            <Box sx={{}}>
              <H2
                sx={{
                  fontSize: {
                    lg: "40px",
                    md: "30px",
                    sm: "20px",
                    xs: "20px",
                  },
                }}
              >
                “EatCoast brings in a lot of business for us. they are the
                easist to work with”
              </H2>
              <P
                sx={{
                  fontSize: {
                    lg: "20px",
                    md: "20px",
                    sm: "16px",
                    xs: "16px",
                  },
                }}
              >
                Alex Prindle, Owner Chef Juna Catering
              </P>
            </Box>
            <Box sx={{}}>
              <H2
                sx={{
                  fontSize: {
                    lg: "40px",
                    md: "30px",
                    sm: "20px",
                    xs: "20px",
                  },
                }}
              >
                “EatCoast brings in a lot of business for us. they are the
                easist to work with”
              </H2>
              <P
                sx={{
                  fontSize: {
                    lg: "20px",
                    md: "20px",
                    sm: "16px",
                    xs: "16px",
                  },
                }}
              >
                Alex Prindle, Owner Chef Juna Catering
              </P>
            </Box>
            <Box sx={{}}>
              <H2
                sx={{
                  fontSize: {
                    lg: "40px",
                    md: "30px",
                    sm: "20px",
                    xs: "20px",
                  },
                }}
              >
                “EatCoast brings in a lot of business for us. they are the
                easist to work with”
              </H2>
              <P
                sx={{
                  fontSize: {
                    lg: "20px",
                    md: "20px",
                    sm: "16px",
                    xs: "16px",
                  },
                }}
              >
                Alex Prindle, Owner Chef Juna Catering
              </P>
            </Box>
          </Slider>
        </Box>

        <Box
          sx={{
            width: { xl: "49%", lg: "49%", md: "37%", sm: "98%", xs: "98%" },
            display: {
              xl: "block",
              lg: "block",
              md: "block",
              sm: "none",
              xs: "none",
            },
          }}
        >
          <img src={img} width="100%" />
        </Box>
      </Box>

      <Container
        className="accordionContainer"
        sx={{ marginTop: 5 }}
        maxWidth="xl"
      >
        {faQs.map((faq, i) => {
          return (
            <>
              <Accordion sx={{ my: 1 }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <P
                    sx={{
                      fontSize: {
                        lg: "20px",
                        md: "20px",
                        sm: "16px",
                        xs: "16px",
                        fontWeight: "500",
                      },
                    }}
                  >
                    {faq.title}
                  </P>
                </AccordionSummary>
                <AccordionDetails>
                  <P sx={{ fontSize: "16px", color: "#1A1824;" }}>{faq.desc}</P>
                </AccordionDetails>
              </Accordion>
            </>
          );
        })}
      </Container>
    </Box>
  );
}

export default Eaist_Way;
